import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "src/app/components/components.module";
import { DepositInstantBankTransferPage } from "./deposit-instant-bank-transfer";

@NgModule({
  declarations: [DepositInstantBankTransferPage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:
  [DepositInstantBankTransferPage]
})
export class DepositInstantBankTransferPageModule {}
